<template>
  <div class="mw-panel">
    <div></div>
  </div>
</template>
<script>
  import Vue from 'vue';
  let vue;
  export default {
    name:"mwTemplate",
    data() {
      return {

      }
    },
    props: {
      value: {
        type: Object
      }
    },
    mounted() {
      let me = this;
      var res = Vue.compile('<el-button @click="test"></el-button>')
      vue=new Vue({
        el:me.$el,
        data: {
          msg: 'hello',
          id:me.id
        },
        methods: {
          test:function(){
          }
        },
        destroyed(){

        },
        render: res.render,
        staticRenderFns: res.staticRenderFns
      })
    },

    watch: {
      value(){

      }
    },

    beforeDestroy(){
      if(vue){

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/table/template.vue